export function setPostLoginHash() {
    const currentHash = window.location.hash || "#/";
    sessionStorage.setItem("postLoginHash", currentHash);
    sessionStorage.setItem("lastRoute", currentHash);
}
